import Vue from 'vue'
import Vuetify, {VSnackbar, VBtn, VIcon} from 'vuetify/lib'
import VueI18n from 'vue-i18n'
import VuetifyToast from 'vuetify-toast-snackbar'

// Using vue loader syntax
Vue.use(Vuetify, {
    components: {
        VBtn,
        VIcon,
        VSnackbar
    }
})

Vue.use(VuetifyToast, {
    x: 'center',
    y: 'bottom'
})

Vue.use(VueI18n)
/*
const messages = {
    de: {
        $vuetify: {
            carousel: {
                ariaLabel: {
                    delimiter: 'carousel-item'
                },
                prev: 'Zurück',
                next: 'Nächster'
            },
            close: 'Schließen',
            datePicker: {
                itemsSelected: '{0} ausgewählt'
            },
            noDataText: 'Keine Daten vorhanden',
            timePicker: {
                am: 'Vorm.',
                pm: 'Nachm.'
            }
        }
    },
    en: {
        $vuetify: {
            carousel: {
                ariaLabel: {
                    delimiter: 'carousel-item'
                },
                prev: 'Prev',
                next: 'Next'
            },
            close: 'Close',
            datePicker: {
                itemsSelected: '{0} selected'
            },
            noDataText: 'No data',
            timePicker: {
                am: 'AM',
                pm: 'PM'
            }
        }
    }
}

// Create VueI18n instance with options
/*const i18n = new VueI18n({
    locale: 'de', // set locale
    fallbackLocale: 'en',
    messages, // set locale messages
})
*/
export default new Vuetify({
/*    lang: {
        t: (key, ...params) => i18n.t(key, params),
    },*/
    theme: {
        themes: {
            light: {
                green: '#4C8F21',
                lime: '#CBD300'
            },
        }
    }
});
